<template>
<div class="ti">
  <div>
    <el-select size="mini" v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="userJid[0]['id']==9002005">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.company_name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-input size="mini" class="search" placeholder="请输入搜索小程序名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">小程序名称</th>
            <th class="text-left">appid</th>
            <!-- <th class="text-left">绑定项目数</th> -->
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.name}}</td>
            <td >{{item.appid}}</td>
            <!-- <td >{{item.number}}</td> -->
            <td >{{item.date}}</td>
            <td class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="xiugai( item.id,item.appid )">装修</div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="编辑首页轮播图和公告"
        @on-ok="ok">
        <div>
          <el-form  label-width="100px" :model="dades">
            <el-form-item label="轮播图" :rules="[{required: true}]">
                <el-upload
                    :action="url"
                    list-type="picture-card"
                    :before-upload="upload"
                    :on-remove="remove"
                    :on-success="success"
                    :file-list ="img">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="公告">
                <el-input type="textarea" v-model="dades.notice"></el-input>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
</div>

</template>

<script>
export default {
  name: 'AppletsHome',
  data () {
    return {
      url:'',
      url1:'',
      img:[],
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      value: [],
      dades: {
        applets_id:'',
        appid:'',
        carousel: [],
        notice:'',
      },
       options: [
        {
          value: '',
          label: ''
        },],
        options1: [
        {
          value: '',
          label: ''
        },],
        opdade:[],
        opdade1:[],
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
    }
  },
  //界面没出来前加载
  created() {
    this.userJid = [{id:''}];
    this.$myhttp.get('admin/lavel3?pid=9002',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // console.log(backdata.data);
        if(backdata.data != 1){
          var date = backdata.data;
          date.forEach(item => {
            //本界面权限
            if(item.id == 9002005){
              this.userJid[0]['id'] = item.id;
            }
          });
        }else{
          //本界面权限
          this.userJid = [{id:'9002005'}];
        }
        // console.log(this.userJid)
      });
  },
  // 加载数据
  mounted(){
    this.url = this.$myhttp.defaults.baseURL + "/admin/posts";
    this.url1 = this.$myhttp.defaults.baseURL;
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    ERP.showLoading()
    this.$Loading.start();
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value1 = 0;
        this.$myhttp.get('admin/applets?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
          ERP.hideLoading()
        });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
        this.options1 = backdata.data[1];
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    // 图片上传
    //点击上传
    upload(file){
      if(this.dades.img){
        this.$Message.error('头像只能上传一张');
        return false;
      }
    },
    //移除
    remove(file, fileList){
      this.dades.img = '';
    },
    //上传成功
    success(response, file, fileList){
        var img = this.url1+'/storage/'+file.response;
        this.img = [{name:'头像',url:img}];
        this.dades.img = '/storage/'+file.response;
        console.log(this.dades.img)
    },
    // 图片上传结束

    //保存
    ok(){
      if(this.dades.name == ""){
        this.$Message.error('小程序名称不能为空!');
        return false;
      }
       if(this.dades.appid == ""){
        this.$Message.error('appid不能为空!');
        return false;
      }
      if(this.dades.AppSecret == ""){
        this.$Message.error('AppSecret不能为空!');
        return false;
      }
      if(this.dades.company_id == ""){
        this.$Message.error('所属组织不能为空!');
        return false;
      }
      if(this.dades.jurisdiction_id == ""){
        this.$Message.error('小程序归属不能为空!');
        return false;
      }
      var pindex = this.dades.pindex_id;
      if(pindex.length <= 0){
        this.$Message.error('绑定项目不能为空!');
        return false;
      }
      this.$Loading.start();
      this.$myhttp.post('admin/appletsAdd',this.dades,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0] == 1){
            this.$myhttp.get('admin/applets?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
            });
            this.$Message.success(backdata.data[1]);
            this.dades={
              id:'',
              name:'',
              company_id:'',
              jurisdiction_id: '',
              appid: '',
              AppSecret:'',
              pindex_id:[],
            };
          }else{
            if(backdata.data[0] == 2){
              this.$Message.error(backdata.data[1]);
            }else{
              this.$Message.error('编辑失败!');
            }
          }
          this.$Loading.finish();
      });
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/applets?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.$Loading.start();
      this.$myhttp.get('admin/applets?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
      });
    },
    //修改查询
    xiugai(e,appid){
      this.$router.push({name:'appletsFitUp',query: { id: e,appid:appid}});
    },
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
</style>
<style>
.el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    line-height: 100px;
    vertical-align: top;
}
.el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    margin: 0 8px 8px 0;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Applets/appletsHome.vue